import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import logo from 'assets/logo.svg'
import clsx from 'clsx'

const MobileNav = ({ isOpenMobileMenu, setIsOpenMobileMenu }) => {
  const [openDropdown] = useState('')
  const [openSubDropdown, setOpenSubDropdown] = useState('')

  return (
    <section className={clsx(
      'fixed top-0 bg-white w-full z-[1] h-screen',
      isOpenMobileMenu ? 'block' : 'hidden'
    )}>
      <div className="flex justify-between items-center py-4 px-6">
        <Link to="/">
          <img className="w-[114px] lg:w-[153px]" src={logo} alt="logo" />
        </Link>
        <CloseIcon onClick={() => setIsOpenMobileMenu(false)}/>
      </div>

      <div className="">
        <div className="flex items-center border border-neutral-30 bg-white rounded-[40px] h-10 px-[14px] gap-x-2 text-neutral-40 text-s-reguler mx-6">
          <SearchIcon/>
          <input type="text" className="" placeholder="Search..."/>
        </div>

        <div className="mt-4">
          {/* Why Manuva */}
          <div className={clsx(
            'overflow-hidden duration-1000 transition-[max-height] ease-in-out',
            openDropdown === 'why-manuva' ? 'max-h-screen' : 'max-h-[40px]'
          )}>
            <Link
              to="/about-us"
              className="flex items-center justify-between py-2 mx-6"
              onClick={() => setIsOpenMobileMenu(false)}
              // onClick={() => openDropdown !== 'why-manuva' ? setOpenDropdown('why-manuva') : setOpenDropdown('')}
            >
              <h1 className="text-m-reguler text-neutral-100">About Us</h1>
              {/* <ArrowIcon className={clsx(
                'transform',
                openDropdown === 'why-manuva' ? 'rotate-180' : 'rotate-0'
              )}/> */}
            </Link>

            <div className="border-l-2 border-l-primary-main bg-[#F7F8FA] pt-2">
              <div className="py-2 px-6 border-b border-b-neutral-30">
                <h1 className="text-s-reguler text-neutral-100">About Us</h1>
              </div>

              <div className="py-2 px-6 mt-2">
                <h1 className="text-s-reguler text-neutral-100">How we work</h1>
              </div>
            </div>
          </div>

          {/* Platform & Service */}
          <div className={clsx(
            'overflow-hidden duration-1000 transition-[max-height] ease-in-out',
            openDropdown === 'platform-service' ? 'max-h-screen' : 'max-h-[40px]'
          )}>
            <Link
              to="/retail"
              className="flex items-center justify-between py-2 mx-6"
              onClick={() => setIsOpenMobileMenu(false)}
              // onClick={() => openDropdown !== 'platform-service' ? setOpenDropdown('platform-service') : setOpenDropdown('')}
            >
              <h1 className="text-m-reguler text-neutral-100">Products and Services</h1>
              {/* <ArrowIcon className={clsx(
                'transform',
                openDropdown === 'platform-service' ? 'rotate-180' : 'rotate-0'
              )}/> */}
            </Link>

            <div className="border-l-2 border-l-primary-main bg-[#F7F8FA] pt-2">
              <div className={clsx(
                'overflow-hidden duration-1000 transition-[max-height] ease-in-out',
                openSubDropdown === 'b2b-customer' ? 'max-h-screen' : 'max-h-[37px]'
              )}>
                <div
                  className="flex justify-between items-center py-2 px-6 border-b border-b-neutral-30"
                  onClick={() => openSubDropdown !== 'b2b-customer' ? setOpenSubDropdown('b2b-customer') : setOpenSubDropdown('')}
                >
                  <h1 className="text-s-reguler text-neutral-100">For B2B Customer</h1>
                  <ArrowIcon className={clsx(
                    'transform',
                    openSubDropdown === 'b2b-customer' ? 'rotate-180' : 'rotate-0'
                  )}/>
                </div>

                <div className="mt-2">
                  <div className="py-2 px-10">
                    <h1 className="text-neutral-100 text-s-reguler">Manuva Procure</h1>
                  </div>

                  <div className="py-2 px-10">
                    <h1 className="text-primary-main text-s-reguler">Made-to-order products and projects</h1>
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center py-2 px-6 border-b border-b-neutral-30 mt-2">
                <h1 className="text-s-reguler text-neutral-100">For Retailer</h1>
                <ArrowIcon/>
              </div>

              <div className="flex justify-between items-center py-2 px-6 mt-2">
                <h1 className="text-s-reguler text-neutral-100">For Manufacturer and Supplier</h1>
                <ArrowIcon/>
              </div>
            </div>
          </div>

          {/* Customers */}
          <div className={clsx(
            'overflow-hidden duration-1000 transition-[max-height] ease-in-out'
          )}>
            <div
              className="flex items-center justify-between py-2 mx-6"
            >
              <h1 className="text-m-reguler text-neutral-100">Customer</h1>
            </div>
          </div>

        </div>

        <div className="px-6 mt-4">
          <button className="bg-primary-main w-full h-10 button-m-bold text-neutral-10 rounded-[100px]">Sign In</button>
          <button className="w-full h-10 button-m-bold text-primary-main mt-4">Sign Up</button>
        </div>

      </div>
    </section>
  )
}

const CloseIcon = ({ className, onClick }) => {
  return (
    <svg onClick={onClick} className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#101838" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.16992 14.8299L14.8299 9.16992" stroke="#101838" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.8299 14.8299L9.16992 9.16992" stroke="#101838" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

const SearchIcon = ({ className }) => {
  return (
    <svg className={className} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.1665 17.1667C13.3086 17.1667 16.6665 13.8089 16.6665 9.66675C16.6665 5.52461 13.3086 2.16675 9.1665 2.16675C5.02437 2.16675 1.6665 5.52461 1.6665 9.66675C1.6665 13.8089 5.02437 17.1667 9.1665 17.1667Z" stroke="#9AA3B2" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.3333 18.8333L15 15.5" stroke="#9AA3B2" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

const ArrowIcon = ({ className }) => {
  return (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.2802 10.0334L8.93355 5.68676C8.42021 5.17342 7.58022 5.17342 7.06688 5.68676L2.72021 10.0334" stroke="#101838" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

ArrowIcon.propTypes = {
  className: PropTypes.string
}

SearchIcon.propTypes = {
  className: PropTypes.string
}

CloseIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

MobileNav.propTypes = {
  isOpenMobileMenu: PropTypes.bool,
  setIsOpenMobileMenu: PropTypes.func
}

export default MobileNav
